/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as LoginImport } from './routes/login';
import { Route as AuthedImport } from './routes/_authed';
import { Route as IndexImport } from './routes/index';
import { Route as AuthedTaskIndexImport } from './routes/_authed/task/index';
import { Route as AuthedSettingIndexImport } from './routes/_authed/setting/index';
import { Route as AuthedProfileIndexImport } from './routes/_authed/profile/index';
import { Route as AuthedOfflineIndexImport } from './routes/_authed/offline/index';
import { Route as AuthedNewsIndexImport } from './routes/_authed/news/index';
import { Route as AuthedHomeIndexImport } from './routes/_authed/home/index';
import { Route as AuthedTaskTaskIdImport } from './routes/_authed/task/$taskId';
import { Route as AuthedRecordFailedImport } from './routes/_authed/record/failed';
import { Route as AuthedNewsNewsIdImport } from './routes/_authed/news/$newsId';
import { Route as AuthedAchievementAchievementIdImport } from './routes/_authed/achievement/$achievementId';
import { Route as AuthedProfileEditIndexImport } from './routes/_authed/profile/edit/index';
import { Route as AuthedTaskTaskIdSportImport } from './routes/_authed/task/$taskId_.sport';
import { Route as AuthedRecordRecordIdSportImport } from './routes/_authed/record/$recordId.sport';
import { Route as AuthedRecordRecordIdFormImport } from './routes/_authed/record/$recordId.form';

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any);

const AuthedRoute = AuthedImport.update({
  id: '/_authed',
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

const AuthedTaskIndexRoute = AuthedTaskIndexImport.update({
  id: '/task/',
  path: '/task/',
  getParentRoute: () => AuthedRoute,
} as any);

const AuthedSettingIndexRoute = AuthedSettingIndexImport.update({
  id: '/setting/',
  path: '/setting/',
  getParentRoute: () => AuthedRoute,
} as any);

const AuthedProfileIndexRoute = AuthedProfileIndexImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AuthedRoute,
} as any);

const AuthedOfflineIndexRoute = AuthedOfflineIndexImport.update({
  id: '/offline/',
  path: '/offline/',
  getParentRoute: () => AuthedRoute,
} as any);

const AuthedNewsIndexRoute = AuthedNewsIndexImport.update({
  id: '/news/',
  path: '/news/',
  getParentRoute: () => AuthedRoute,
} as any);

const AuthedHomeIndexRoute = AuthedHomeIndexImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AuthedRoute,
} as any);

const AuthedTaskTaskIdRoute = AuthedTaskTaskIdImport.update({
  id: '/task/$taskId',
  path: '/task/$taskId',
  getParentRoute: () => AuthedRoute,
} as any);

const AuthedRecordFailedRoute = AuthedRecordFailedImport.update({
  id: '/record/failed',
  path: '/record/failed',
  getParentRoute: () => AuthedRoute,
} as any);

const AuthedNewsNewsIdRoute = AuthedNewsNewsIdImport.update({
  id: '/news/$newsId',
  path: '/news/$newsId',
  getParentRoute: () => AuthedRoute,
} as any);

const AuthedAchievementAchievementIdRoute =
  AuthedAchievementAchievementIdImport.update({
    id: '/achievement/$achievementId',
    path: '/achievement/$achievementId',
    getParentRoute: () => AuthedRoute,
  } as any);

const AuthedProfileEditIndexRoute = AuthedProfileEditIndexImport.update({
  id: '/profile/edit/',
  path: '/profile/edit/',
  getParentRoute: () => AuthedRoute,
} as any);

const AuthedTaskTaskIdSportRoute = AuthedTaskTaskIdSportImport.update({
  id: '/task/$taskId_/sport',
  path: '/task/$taskId/sport',
  getParentRoute: () => AuthedRoute,
} as any);

const AuthedRecordRecordIdSportRoute = AuthedRecordRecordIdSportImport.update({
  id: '/record/$recordId/sport',
  path: '/record/$recordId/sport',
  getParentRoute: () => AuthedRoute,
} as any);

const AuthedRecordRecordIdFormRoute = AuthedRecordRecordIdFormImport.update({
  id: '/record/$recordId/form',
  path: '/record/$recordId/form',
  getParentRoute: () => AuthedRoute,
} as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/_authed': {
      id: '/_authed';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof AuthedImport;
      parentRoute: typeof rootRoute;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginImport;
      parentRoute: typeof rootRoute;
    };
    '/_authed/achievement/$achievementId': {
      id: '/_authed/achievement/$achievementId';
      path: '/achievement/$achievementId';
      fullPath: '/achievement/$achievementId';
      preLoaderRoute: typeof AuthedAchievementAchievementIdImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/news/$newsId': {
      id: '/_authed/news/$newsId';
      path: '/news/$newsId';
      fullPath: '/news/$newsId';
      preLoaderRoute: typeof AuthedNewsNewsIdImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/record/failed': {
      id: '/_authed/record/failed';
      path: '/record/failed';
      fullPath: '/record/failed';
      preLoaderRoute: typeof AuthedRecordFailedImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/task/$taskId': {
      id: '/_authed/task/$taskId';
      path: '/task/$taskId';
      fullPath: '/task/$taskId';
      preLoaderRoute: typeof AuthedTaskTaskIdImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/home/': {
      id: '/_authed/home/';
      path: '/home';
      fullPath: '/home';
      preLoaderRoute: typeof AuthedHomeIndexImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/news/': {
      id: '/_authed/news/';
      path: '/news';
      fullPath: '/news';
      preLoaderRoute: typeof AuthedNewsIndexImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/offline/': {
      id: '/_authed/offline/';
      path: '/offline';
      fullPath: '/offline';
      preLoaderRoute: typeof AuthedOfflineIndexImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/profile/': {
      id: '/_authed/profile/';
      path: '/profile';
      fullPath: '/profile';
      preLoaderRoute: typeof AuthedProfileIndexImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/setting/': {
      id: '/_authed/setting/';
      path: '/setting';
      fullPath: '/setting';
      preLoaderRoute: typeof AuthedSettingIndexImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/task/': {
      id: '/_authed/task/';
      path: '/task';
      fullPath: '/task';
      preLoaderRoute: typeof AuthedTaskIndexImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/record/$recordId/form': {
      id: '/_authed/record/$recordId/form';
      path: '/record/$recordId/form';
      fullPath: '/record/$recordId/form';
      preLoaderRoute: typeof AuthedRecordRecordIdFormImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/record/$recordId/sport': {
      id: '/_authed/record/$recordId/sport';
      path: '/record/$recordId/sport';
      fullPath: '/record/$recordId/sport';
      preLoaderRoute: typeof AuthedRecordRecordIdSportImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/task/$taskId_/sport': {
      id: '/_authed/task/$taskId_/sport';
      path: '/task/$taskId/sport';
      fullPath: '/task/$taskId/sport';
      preLoaderRoute: typeof AuthedTaskTaskIdSportImport;
      parentRoute: typeof AuthedImport;
    };
    '/_authed/profile/edit/': {
      id: '/_authed/profile/edit/';
      path: '/profile/edit';
      fullPath: '/profile/edit';
      preLoaderRoute: typeof AuthedProfileEditIndexImport;
      parentRoute: typeof AuthedImport;
    };
  }
}

// Create and export the route tree

interface AuthedRouteChildren {
  AuthedAchievementAchievementIdRoute: typeof AuthedAchievementAchievementIdRoute;
  AuthedNewsNewsIdRoute: typeof AuthedNewsNewsIdRoute;
  AuthedRecordFailedRoute: typeof AuthedRecordFailedRoute;
  AuthedTaskTaskIdRoute: typeof AuthedTaskTaskIdRoute;
  AuthedHomeIndexRoute: typeof AuthedHomeIndexRoute;
  AuthedNewsIndexRoute: typeof AuthedNewsIndexRoute;
  AuthedOfflineIndexRoute: typeof AuthedOfflineIndexRoute;
  AuthedProfileIndexRoute: typeof AuthedProfileIndexRoute;
  AuthedSettingIndexRoute: typeof AuthedSettingIndexRoute;
  AuthedTaskIndexRoute: typeof AuthedTaskIndexRoute;
  AuthedRecordRecordIdFormRoute: typeof AuthedRecordRecordIdFormRoute;
  AuthedRecordRecordIdSportRoute: typeof AuthedRecordRecordIdSportRoute;
  AuthedTaskTaskIdSportRoute: typeof AuthedTaskTaskIdSportRoute;
  AuthedProfileEditIndexRoute: typeof AuthedProfileEditIndexRoute;
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAchievementAchievementIdRoute: AuthedAchievementAchievementIdRoute,
  AuthedNewsNewsIdRoute: AuthedNewsNewsIdRoute,
  AuthedRecordFailedRoute: AuthedRecordFailedRoute,
  AuthedTaskTaskIdRoute: AuthedTaskTaskIdRoute,
  AuthedHomeIndexRoute: AuthedHomeIndexRoute,
  AuthedNewsIndexRoute: AuthedNewsIndexRoute,
  AuthedOfflineIndexRoute: AuthedOfflineIndexRoute,
  AuthedProfileIndexRoute: AuthedProfileIndexRoute,
  AuthedSettingIndexRoute: AuthedSettingIndexRoute,
  AuthedTaskIndexRoute: AuthedTaskIndexRoute,
  AuthedRecordRecordIdFormRoute: AuthedRecordRecordIdFormRoute,
  AuthedRecordRecordIdSportRoute: AuthedRecordRecordIdSportRoute,
  AuthedTaskTaskIdSportRoute: AuthedTaskTaskIdSportRoute,
  AuthedProfileEditIndexRoute: AuthedProfileEditIndexRoute,
};

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '': typeof AuthedRouteWithChildren;
  '/login': typeof LoginRoute;
  '/achievement/$achievementId': typeof AuthedAchievementAchievementIdRoute;
  '/news/$newsId': typeof AuthedNewsNewsIdRoute;
  '/record/failed': typeof AuthedRecordFailedRoute;
  '/task/$taskId': typeof AuthedTaskTaskIdRoute;
  '/home': typeof AuthedHomeIndexRoute;
  '/news': typeof AuthedNewsIndexRoute;
  '/offline': typeof AuthedOfflineIndexRoute;
  '/profile': typeof AuthedProfileIndexRoute;
  '/setting': typeof AuthedSettingIndexRoute;
  '/task': typeof AuthedTaskIndexRoute;
  '/record/$recordId/form': typeof AuthedRecordRecordIdFormRoute;
  '/record/$recordId/sport': typeof AuthedRecordRecordIdSportRoute;
  '/task/$taskId/sport': typeof AuthedTaskTaskIdSportRoute;
  '/profile/edit': typeof AuthedProfileEditIndexRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '': typeof AuthedRouteWithChildren;
  '/login': typeof LoginRoute;
  '/achievement/$achievementId': typeof AuthedAchievementAchievementIdRoute;
  '/news/$newsId': typeof AuthedNewsNewsIdRoute;
  '/record/failed': typeof AuthedRecordFailedRoute;
  '/task/$taskId': typeof AuthedTaskTaskIdRoute;
  '/home': typeof AuthedHomeIndexRoute;
  '/news': typeof AuthedNewsIndexRoute;
  '/offline': typeof AuthedOfflineIndexRoute;
  '/profile': typeof AuthedProfileIndexRoute;
  '/setting': typeof AuthedSettingIndexRoute;
  '/task': typeof AuthedTaskIndexRoute;
  '/record/$recordId/form': typeof AuthedRecordRecordIdFormRoute;
  '/record/$recordId/sport': typeof AuthedRecordRecordIdSportRoute;
  '/task/$taskId/sport': typeof AuthedTaskTaskIdSportRoute;
  '/profile/edit': typeof AuthedProfileEditIndexRoute;
}

export interface FileRoutesById {
  '__root__': typeof rootRoute;
  '/': typeof IndexRoute;
  '/_authed': typeof AuthedRouteWithChildren;
  '/login': typeof LoginRoute;
  '/_authed/achievement/$achievementId': typeof AuthedAchievementAchievementIdRoute;
  '/_authed/news/$newsId': typeof AuthedNewsNewsIdRoute;
  '/_authed/record/failed': typeof AuthedRecordFailedRoute;
  '/_authed/task/$taskId': typeof AuthedTaskTaskIdRoute;
  '/_authed/home/': typeof AuthedHomeIndexRoute;
  '/_authed/news/': typeof AuthedNewsIndexRoute;
  '/_authed/offline/': typeof AuthedOfflineIndexRoute;
  '/_authed/profile/': typeof AuthedProfileIndexRoute;
  '/_authed/setting/': typeof AuthedSettingIndexRoute;
  '/_authed/task/': typeof AuthedTaskIndexRoute;
  '/_authed/record/$recordId/form': typeof AuthedRecordRecordIdFormRoute;
  '/_authed/record/$recordId/sport': typeof AuthedRecordRecordIdSportRoute;
  '/_authed/task/$taskId_/sport': typeof AuthedTaskTaskIdSportRoute;
  '/_authed/profile/edit/': typeof AuthedProfileEditIndexRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | ''
    | '/login'
    | '/achievement/$achievementId'
    | '/news/$newsId'
    | '/record/failed'
    | '/task/$taskId'
    | '/home'
    | '/news'
    | '/offline'
    | '/profile'
    | '/setting'
    | '/task'
    | '/record/$recordId/form'
    | '/record/$recordId/sport'
    | '/task/$taskId/sport'
    | '/profile/edit';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | ''
    | '/login'
    | '/achievement/$achievementId'
    | '/news/$newsId'
    | '/record/failed'
    | '/task/$taskId'
    | '/home'
    | '/news'
    | '/offline'
    | '/profile'
    | '/setting'
    | '/task'
    | '/record/$recordId/form'
    | '/record/$recordId/sport'
    | '/task/$taskId/sport'
    | '/profile/edit';
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login'
    | '/_authed/achievement/$achievementId'
    | '/_authed/news/$newsId'
    | '/_authed/record/failed'
    | '/_authed/task/$taskId'
    | '/_authed/home/'
    | '/_authed/news/'
    | '/_authed/offline/'
    | '/_authed/profile/'
    | '/_authed/setting/'
    | '/_authed/task/'
    | '/_authed/record/$recordId/form'
    | '/_authed/record/$recordId/sport'
    | '/_authed/task/$taskId_/sport'
    | '/_authed/profile/edit/';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthedRoute: typeof AuthedRouteWithChildren;
  LoginRoute: typeof LoginRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authed",
        "/login"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authed": {
      "filePath": "_authed.tsx",
      "children": [
        "/_authed/achievement/$achievementId",
        "/_authed/news/$newsId",
        "/_authed/record/failed",
        "/_authed/task/$taskId",
        "/_authed/home/",
        "/_authed/news/",
        "/_authed/offline/",
        "/_authed/profile/",
        "/_authed/setting/",
        "/_authed/task/",
        "/_authed/record/$recordId/form",
        "/_authed/record/$recordId/sport",
        "/_authed/task/$taskId_/sport",
        "/_authed/profile/edit/"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/_authed/achievement/$achievementId": {
      "filePath": "_authed/achievement/$achievementId.tsx",
      "parent": "/_authed"
    },
    "/_authed/news/$newsId": {
      "filePath": "_authed/news/$newsId.tsx",
      "parent": "/_authed"
    },
    "/_authed/record/failed": {
      "filePath": "_authed/record/failed.tsx",
      "parent": "/_authed"
    },
    "/_authed/task/$taskId": {
      "filePath": "_authed/task/$taskId.tsx",
      "parent": "/_authed"
    },
    "/_authed/home/": {
      "filePath": "_authed/home/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/news/": {
      "filePath": "_authed/news/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/offline/": {
      "filePath": "_authed/offline/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/profile/": {
      "filePath": "_authed/profile/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/setting/": {
      "filePath": "_authed/setting/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/task/": {
      "filePath": "_authed/task/index.tsx",
      "parent": "/_authed"
    },
    "/_authed/record/$recordId/form": {
      "filePath": "_authed/record/$recordId.form.tsx",
      "parent": "/_authed"
    },
    "/_authed/record/$recordId/sport": {
      "filePath": "_authed/record/$recordId.sport.tsx",
      "parent": "/_authed"
    },
    "/_authed/task/$taskId_/sport": {
      "filePath": "_authed/task/$taskId_.sport.tsx",
      "parent": "/_authed"
    },
    "/_authed/profile/edit/": {
      "filePath": "_authed/profile/edit/index.tsx",
      "parent": "/_authed"
    }
  }
}
ROUTE_MANIFEST_END */
